module.exports = __webpack_public_path__ + "static/media/br.38a61e70.svg";